package com.milta.feature.admin.data.remote.dto

import com.milta.feature.admin.domain.entity.AdminOcrAnalysis
import com.milta.feature.admin.domain.entity.AdminOcrAnalysisModeSummary
import com.milta.feature.admin.domain.entity.AdminOcrAnalysisSummary
import kotlinx.serialization.Serializable

// Field names match the backend's camelCase JSON exactly (System.Text.Json default) — see
// Milta.Application.Admin.Dtos.AdminOcrAnalysisResponseDto in the milta (backend) repo.

@Serializable
data class AdminOcrAnalysisResponseDto(
    val summary: AdminOcrAnalysisSummaryDto,
    val modeSummaries: List<AdminOcrAnalysisModeSummaryDto>,
)

@Serializable
data class AdminOcrAnalysisSummaryDto(
    val totalDocuments: Int,
    val completedDocuments: Int,
    val totalRealCost: Double,
    val documentsByFileKind: Map<String, Int>,
    val totalInputTokens: Int,
    val totalOutputTokens: Int,
)

@Serializable
data class AdminOcrAnalysisModeSummaryDto(
    val mode: String,
    val documentCount: Int,
    val claudeCallCount: Int,
    val totalProjectedCost: Double,
    val totalRealCostForModeSet: Double,
    val projectedSavings: Double,
)

fun AdminOcrAnalysisResponseDto.toDomain() = AdminOcrAnalysis(
    summary = summary.toDomain(),
    modeSummaries = modeSummaries.map { it.toDomain() },
)

fun AdminOcrAnalysisSummaryDto.toDomain() = AdminOcrAnalysisSummary(
    totalDocuments = totalDocuments,
    completedDocuments = completedDocuments,
    totalRealCost = totalRealCost,
    documentsByFileKind = documentsByFileKind,
    totalInputTokens = totalInputTokens,
    totalOutputTokens = totalOutputTokens,
)

fun AdminOcrAnalysisModeSummaryDto.toDomain() = AdminOcrAnalysisModeSummary(
    mode = mode,
    documentCount = documentCount,
    claudeCallCount = claudeCallCount,
    totalProjectedCost = totalProjectedCost,
    totalRealCostForModeSet = totalRealCostForModeSet,
    projectedSavings = projectedSavings,
)
